import React, { useEffect, useState } from "react";
import { api } from "../api/client";

type AdminNewsItem = {
  id: number;
  title: string;
  status: string;
  created_at: string;
  updated_at: string;
  author_email?: string;
};

export const AdminNewsPage: React.FC = () => {
  const [items, setItems] = useState<AdminNewsItem[]>([]);

  const load = async () => {
    const res = await api.get("/news/admin");
    setItems(res.data.items);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <h1>Admin – News</h1>
      <p>Basic-Übersicht – Bearbeitungsmaske bauen wir im nächsten Schritt.</p>
      <table>
        <thead>
          <tr>
            <th>Titel</th>
            <th>Status</th>
            <th>Autor</th>
            <th>Erstellt</th>
            <th>Geändert</th>
          </tr>
        </thead>
        <tbody>
          {items.map((n) => (
            <tr key={n.id}>
              <td>{n.title}</td>
              <td>{n.status}</td>
              <td>{n.author_email || "–"}</td>
              <td>{new Date(n.created_at).toLocaleString("de-DE")}</td>
              <td>{new Date(n.updated_at).toLocaleString("de-DE")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
